import { H1, Text } from '../ui/typography';
import PageSeo from '../seo/PageSeo';

function Pricelist() {
  const pricelist = [
    { title: "Uvodno srečanje", price: "70", time: "50" },
    { title: "Individualna psihoterapija", price: "70", time: "50" },
    { title: "Partnerska psihoterapija", price: "80", time: "50" },
    { title: "Družinska psihoterapija", price: "80", time: "50" }
  ];

  return (
    <>
      <PageSeo
        title="Cenik | Psihoterapija Špela Verbnik"
        description="Cenik psihoterapije in psihološkega svetovanja v Ljubljani. Uvodno srečanje, individualna, partnerska in družinska psihoterapija."
        path="/pricelist"
      />
    <div className='bg-primaryBg pl-4 pr-4'>
      <div className="lg:w-1/2 m-auto flex flex-col items-center align-middle pt-12 pb-12">
        <H1 style={{color: "#616287"}}>Cenik</H1>
        <div className='pt-12' style={{width: "60%"}}>
          {pricelist.map((value, idx) => (
            <div key={`pricelist_${idx}`} className={`flex flex-row w-full pt-4 pb-4 ${idx != pricelist.length - 1 ? "border-b-[1px]" : ""} border-secondaryBg`}>
              <div className='w-1/2'><Text className="sm:m-auto text-left text-base">{value.title}</Text></div>              
              <div className='w-1/2'><Text className="sm:m-auto sm:text-right lg:text-right text-base">{value.price} €</Text></div>
            </div>
          ))}
        </div>
        <Text className="text-base pt-6 text-center">Psihoterapevtsko srečanje traja 50 minut</Text>
        <Text className="text-base pt-12">*Cene in trajanje veljajo enako za psihoterapijo in psihološko svetovanje.</Text>
        <Text className="text-base pt-12">Zavedam se, da se lahko med terapevtskim procesom pojavijo nepričakovane spremembe v finančnem položaju. V kolikor bi plačevanje psihoterapije po dogovorjeni ceni za vas postalo začasno neizvedljivo, obstaja možnost dogovora o znižanem znesku za določeno obdobje.</Text>
      </div>
    </div>
      
    </>
    
  );
}

export default Pricelist; 